module.exports = __webpack_public_path__ + "img/tooltip_09-vallone-litho-finish-cement.790f6db4.jpg";